/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Placeholder_MinInputs */

const en_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. 8 characters`)
};

const de_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mind. 8 Zeichen`)
};

const fr_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. 8 caractères`)
};

const es_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mín. 8 caracteres`)
};

const it_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. 8 caratteri`)
};

const nl_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. 8 tekens`)
};

const pl_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. 8 znaków`)
};

const fi_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vähintään 8 merkkiä`)
};

const da_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. 8 tegn`)
};

const sv_auth_password_placeholder_min = /** @type {(inputs: Auth_Password_Placeholder_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. 8 tecken`)
};

/**
* | output |
* | --- |
* | "Min. 8 characters" |
*
* @param {Auth_Password_Placeholder_MinInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_password_placeholder_min = /** @type {((inputs?: Auth_Password_Placeholder_MinInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Placeholder_MinInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_password_placeholder_min(inputs)
	if (locale === "fr") return fr_auth_password_placeholder_min(inputs)
	if (locale === "es") return es_auth_password_placeholder_min(inputs)
	if (locale === "it") return it_auth_password_placeholder_min(inputs)
	if (locale === "nl") return nl_auth_password_placeholder_min(inputs)
	if (locale === "pl") return pl_auth_password_placeholder_min(inputs)
	if (locale === "fi") return fi_auth_password_placeholder_min(inputs)
	if (locale === "da") return da_auth_password_placeholder_min(inputs)
	if (locale === "sv") return sv_auth_password_placeholder_min(inputs)
	return en_auth_password_placeholder_min(inputs)
});